var map = {
	"./school-0.png": "Opiu",
	"./school-1.png": "Nvgv",
	"./school-10.png": "2kyd",
	"./school-11.png": "HnRZ",
	"./school-12.png": "4Xyv",
	"./school-13.png": "x3uK",
	"./school-14.png": "mBY+",
	"./school-15.png": "87dw",
	"./school-16.png": "q3gn",
	"./school-17.png": "BGA5",
	"./school-2.png": "VWVV",
	"./school-3.png": "lUE7",
	"./school-4.png": "Rdrj",
	"./school-5.png": "dKhA",
	"./school-6.png": "MCWC",
	"./school-7.png": "CffV",
	"./school-8.png": "F2KE",
	"./school-9.png": "hchC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "u7hX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home ^\.\/school\-.*\.png$
// module id = u7hX
// module chunks = 1